import { accidentFreeMessages, AccidentOptions, knownAccidentsMessages } from "@slfinrtl/ui-bff-routes"
import { useIntl } from "react-intl"
import type { RadioOption } from "src/components/form/radio/radioGroup/RadioGroup"

export const useAccidentOptions = (isAccidentFreeDisplayed: boolean): RadioOption[] => {
	const { formatMessage } = useIntl()
	const messages = isAccidentFreeDisplayed ? accidentFreeMessages : knownAccidentsMessages
	return [
		{
			label: formatMessage(messages.ACCIDENT_FREE),
			value: AccidentOptions.ACCIDENT_FREE,
		},
		{
			label: formatMessage(messages.NOT_ACCIDENT_FREE),
			value: AccidentOptions.NOT_ACCIDENT_FREE,
		},
	]
}
